import { render, staticRenderFns } from "./customerSupper.vue?vue&type=template&id=2d31ebe1&scoped=true&"
import script from "./customerSupper.vue?vue&type=script&lang=js&"
export * from "./customerSupper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d31ebe1",
  null
  
)

export default component.exports